export default "__VITE_ASSET__w$2W85SC__";